(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (customElements.get("announcement-bar-component") == undefined) {
    class AnnouncementBar extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.closeAnnouncementButton = this.querySelector("[data-close-announcement]");
        this.announcementBarSlider = this.querySelector("[data-announcement-bar]");
        this.announcementHasSlides =
          this.announcementBarSlider?.querySelectorAll(".announcement-bar__message").length > 1;

        if (AnnouncementBar.getCookie("announcement") == "closed") {
          this.remove();
        } else {
          this.style.opacity = 1;
          this.style.visibility = "visible";
        }

        document.addEventListener("DOMContentLoaded", () => {
          this.initAnnouncementBarSlider();
          this.closeAnnouncementButton?.addEventListener("click", this.closeAnnouncementBar.bind(this));
        });
      }

      closeAnnouncementBar(e) {
        e.preventDefault();
        e.stopPropagation();

        this.remove();
        AnnouncementBar.setCookie("announcement", "closed", 1);
      }

      initAnnouncementBarSlider() {
        if (this.announcementHasSlides && !this.announcementBarSlider.classList.contains("slick-initialized")) {
          let showArrows;
          this.announcementBarSlider.dataset.arrows == "true" || this.announcementBarSlider.dataset.arrows == true
            ? (showArrows = true)
            : (showArrows = false);
          $(this.announcementBarSlider).slick({
            infinite: true,
            vertical: false,
            adaptiveHeight: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: showArrows,
            autoplay: true,
            autoplaySpeed: 3000,
            nextArrow:
              '<button type="button" class="slick-next" aria-label="Next"><svg viewBox="0 0 478.448 478.448" class="icon icon-chevron-right" id="icon-chevron-right"><g><g><polygon points="131.659,0 100.494,32.035 313.804,239.232 100.494,446.373 131.65,478.448 377.954,239.232"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>',
            prevArrow:
              '<button type="button" class="slick-prev" aria-label="Previous"><svg viewBox="0 0 370.814 370.814" class="icon icon-chevron-left" id="icon-chevron-left"><g><g><polygon points="292.92,24.848 268.781,0 77.895,185.401 268.781,370.814 292.92,345.961 127.638,185.401"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>',
          });
        }
      }

      static setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      }

      static getCookie(cname) {
        const name = cname + "=";
        const ca = document.cookie.split(";");

        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) === " ") {
            c = c.substring(1);
          }
          if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
          }
        }

        return "";
      }
    }

    customElements.define("announcement-bar-component", AnnouncementBar);

    const elementToAnimate = document.querySelector(".announcement-bar");
    function toggleActiveClass() {
      const viewportHeight = window.innerHeight;
      const elementRect = elementToAnimate.getBoundingClientRect();

      if (elementRect.top < viewportHeight && elementRect.bottom >= 0) {
        elementToAnimate.classList.add("active-screen");
      } else {
        elementToAnimate.classList.remove("active-screen");
      }
    }

    window.addEventListener("scroll", toggleActiveClass);
    toggleActiveClass();
  }

  if (window.announcementClosed) {
    document.querySelector(".announcement-bar").remove();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }

        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
                
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-banners"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const scrollableContainers = document.querySelectorAll(
      ".collection-banners-section .collection-banner-icons__inner"
    );

    scrollableContainers.forEach((scrollableContainer) => {
      scrollableContainer.addEventListener("scroll", function (e) {
        const maxLeft = Math.max(0, scrollableContainer.scrollWidth - scrollableContainer.clientWidth);
        const scrollOffset = 10;

        scrollableContainer.parentElement.classList.toggle(
          "can-scroll-left",
          scrollableContainer.scrollLeft > scrollOffset
        );
        scrollableContainer.parentElement.classList.toggle(
          "can-scroll-right",
          scrollableContainer.scrollLeft < maxLeft - scrollOffset
        );
      });

      scrollableContainer.dispatchEvent(new Event("scroll"));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections-showcase"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const scrollableContainer = document.querySelector(".collections-showcase-section .items-wrapper");

    scrollableContainer.addEventListener("scroll", function (e) {
      const maxLeft = Math.max(0, scrollableContainer.scrollWidth - scrollableContainer.clientWidth);
      const scrollOffset = 10;

      scrollableContainer.parentElement.classList.toggle(
        "can-scroll-left",
        scrollableContainer.scrollLeft > scrollOffset
      );
      scrollableContainer.parentElement.classList.toggle(
        "can-scroll-right",
        scrollableContainer.scrollLeft < maxLeft - scrollOffset
      );
    });

    scrollableContainer.dispatchEvent(new Event("scroll"));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["destaques"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    // Initialize Swiper
    const swiper = new Swiper(".container-destaques", {
      slidesPerView: "auto",
      freeMode: true,
      breakpoints: {
        375: {
          slidesPerView: "auto",
        },
        551: {
          slidesPerView: 2.05,
        },
        768: {
          slidesPerView: 2.8,
        },
        1024: {
          slidesPerView: "auto",
          pagination: {
            enabled: false,
          },
        },
        1200: {
          slidesPerView: "auto",
        },
      },
      on: {
        afterInit: centerIfLocked,
        resize: centerIfLocked,
        observerUpdate: centerIfLocked,
      },
      pagination: {
        el: ".swiper-pagination",
      },
    });

    function centerIfLocked(sw) {
      // `wrapperEl` is the <div class="swiper-wrapper">
      sw.wrapperEl.style.justifyContent = sw.isLocked ? "center" : "";
      sw.hostEl.style.paddingBlock = sw.isLocked ? "" : "8px";
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halo-toolbar-mobile"]) return;
  try {
    
  const buttons = document.querySelectorAll("[data-bar-content]");
  if (buttons.length) {
    buttons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        if (event.target.nextSibling.classList.contains("show")) {
          event.target.nextSibling.classList.remove("show");
          document.querySelector("body").classList.remove("show-sidebar-content");
        } else {
          event.target.nextSibling.classList.add("show");
          document.querySelector("body").classList.add("show-sidebar-content");
        }
      });
    });
    document.querySelectorAll("[data-close-content-sidebar]").forEach((button) => {
      button.addEventListener("click", (event) => {
        event.target.closest(".bottom-bar--content").classList.remove("show");
        document.querySelector("body").classList.remove("show-sidebar-content");
      });
    });
  }
  $("body").addClass("sticky-toolbar-mobile");

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mobile"]) return;
  try {
    
  class StickyHeaderMobile extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector(".section-header-mobile");
      this.headerIsAlwaysSticky =
        this.getAttribute("data-sticky-type") === "always" ||
        this.getAttribute("data-sticky-type") === "reduce-logo-size";
      this.headerBounds = {};

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add("shopify-section-header-sticky");
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector("predictive-search");

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
      window.addEventListener("scroll", this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
      window.removeEventListener("scroll", this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add("scrolled-past-header");
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add("scrolled-past-header");
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove("scrolled-past-header");
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add("shopify-section-header-hidden", "shopify-section-header-sticky");
      this.header.classList.remove("shopify-section-header-show");
      this.header.style.top = "";
    }

    reveal() {
      const headerMultiSite = document.querySelector(".section-header-nav-multi-site");
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add("shopify-section-header-sticky", "shopify-section-header-show", "animate");
      this.header.classList.remove("shopify-section-header-hidden");
      if (headerMultiSite) {
        const height = headerMultiSite.offsetHeight;
        this.header.style.top = `${height}px`;
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove(
        "shopify-section-header-hidden",
        "shopify-section-header-show",
        "shopify-section-header-sticky",
        "animate"
      );
      this.header.style.top = "";
    }
  }

  customElements.define("sticky-header-mobile", StickyHeaderMobile);

  document.querySelectorAll("[data-mobile-menu]").forEach((menu) => {
    menu.addEventListener("click", () => {
      document.body.classList.toggle("menu_open");
    });
  });

  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function renderLogoMobile() {
    if ($("[data-menu-tab]").length > 0) {
      $(document).on("click", "[data-menu-tab] li", (event) => {
        var active = $(event.currentTarget).data("load-page"),
          href = $(event.currentTarget).attr("href");

        $.cookie("page-url", active, {
          expires: 1,
          path: "/",
        });
      });

      var canonical = $("[canonical-shop-url]").attr("canonical-shop-url"),
        pageUrl = $.cookie("page-url"),
        menuTabItem,
        logoTabItem,
        menuItem;

      if (window.location.pathname.indexOf("/pages/") !== -1 && window.page_active && window.page_active != pageUrl) {
        setCookie("page-url", window.page_active, 1);
        pageUrl = window.page_active;
      }

      if (pageUrl != null) {
        menuTabItem = $(`[data-load-page="${pageUrl}"]`);
        logoTabItem = $(`[data-load-logo-page="${pageUrl}"]`);
        menuItem = $(`[data-load-menu-page="${pageUrl}"]`);
      } else {
        menuTabItem = $("[data-load-page].is-active");
        logoTabItem = $("[data-load-logo-page].first");
        menuItem = $("[data-load-menu-page].is-active");
      }

      var menuTab = menuTabItem.closest("[data-menu-tab]");

      menuTab.find("[data-load-page]").not(menuTabItem).removeClass("is-active");
      logoTabItem.siblings().removeClass("is-active");
      menuItem.siblings().removeClass("is-active");
      if (pageUrl != "") {
        logoTabItem.addClass("is-active");
        menuTabItem.addClass("is-active");
        menuItem.addClass("is-active");
      } else {
        $("[data-load-page]:nth-child(1)").addClass("is-active");
        $("[data-load-logo-page]:nth-child(1)").addClass("is-active");
        $("[data-load-menu-page]:nth-child(1)").addClass("is-active");
      }

      const header = menuTabItem.closest(".header");

      if (header && window.innerWidth < 1025) {
        if (window.location.pathname.indexOf("/pages/") !== -1 && window.page_active && window.page_active != pageUrl) {
          setCookie("page-url", window.page_active, 1);
          pageUrl = window.page_active;
        }

        const logoMobile = $(".header-mobile .header__heading-link");
        const logDesktop = header.find(".header__heading-link.is-active");

        if (logDesktop.data("logo-mobile") == undefined) {
          logoMobile.find("img").addClass("logo-show");
          return;
        } else {
          logoMobile.html(
            `<img src="${logDesktop.data("logo-mobile")}" alt="${logDesktop.data(
              "logo-mobile-alt"
            )}" style="max-width: ${logoMobile.data("logo-width")}px; height: auto"/>`
          );

          logoMobile.find("img").addClass("logo-show");
          if (pageUrl != "" && pageUrl != null) logoMobile.attr("href", pageUrl);
        }
      }
    }
  }

  renderLogoMobile();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-multi-site');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);
              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    document.addEventListener('DOMContentLoaded', () => {customElements.define('sticky-header', StickyHeader)});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-basic"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-basic');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-compact"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-compact');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-full-elements"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-full-elements');
if (sticky != undefined || sticky != null) {

    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-hamburger"] && !Shopify.designMode) return;
  try {
    
  var sticky = document.getElementsByTagName("sticky-header")[0].querySelector(".header-nav-hamburger");
  if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.header = document.querySelector(".section-header-navigation");
        this.headerIsAlwaysSticky = this.getAttribute("data-sticky-type");
        this.headerBounds = {};
        this.setHeaderHeight();
        window.matchMedia("(max-width: 990px)").addEventListener("change", this.setHeaderHeight.bind(this));
        if (this.headerIsAlwaysSticky) {
          this.header.classList.add("shopify-section-header-sticky");
        }
        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector("predictive-search");
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
        this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
        window.addEventListener("load", this.checkLoadPosition.bind(this));
        window.addEventListener("scroll", this.onScrollHandler, false);
        this.createObserver();
      }
      setHeaderHeight() {
        document.documentElement.style.setProperty("--header-height", `${this.header.offsetHeight}px`);
      }
      disconnectedCallback() {
        this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
        window.removeEventListener("load", this.checkLoadPosition);
        window.removeEventListener("scroll", this.onScrollHandler);
      }
      createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });
        observer.observe(this.header);
      }
      checkLoadPosition() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const headerGr = document.querySelectorAll(".shopify-section-group-header-group");

        if (headerGr[0].classList.contains("shopify-section-header-sticky")) {
          if (scrollTop > headerGr[0].offsetHeight && !this.header.classList.contains("scrolled-past-header")) {
            this.header.classList.add("shopify-section-header-hidden");
          }
        } else {
          headerGr.forEach((item) => {
            if (item.classList.contains("shopify-section-header-sticky")) {
              const itemPrev = item.previousElementSibling;
              const itemPrevHeight = itemPrev.offsetHeight;
              const itemPrevTop = itemPrev.offsetTop;

              if (scrollTop > itemPrevTop + itemPrevHeight && !this.header.classList.contains("scrolled-past-header")) {
                if (this.headerIsAlwaysSticky != "always") {
                  this.header.classList.add("shopify-section-header-hidden");
                }
              }
            }
          });
        }
      }
      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (this.preventHide) return;
          this.header.classList.add("scrolled-past-header");
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add("scrolled-past-header");
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);
            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove("scrolled-past-header");
          requestAnimationFrame(this.reset.bind(this));
        }
        this.currentScrollTop = scrollTop;
      }
      hide() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === "always") {
            this.header.classList.add("shopify-section-header-sticky");
            return;
          } else {
            this.header.classList.add("shopify-section-header-hidden", "shopify-section-header-sticky");
            this.header.classList.remove("shopify-section-header-show");
            document.querySelector("body").classList.add("section-header-is-hidden");
          }
        }
        this.closeMenuDisclosure();
      }
      reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === "always") {
            this.header.classList.add("shopify-section-header-sticky", "animate");
            return;
          } else {
            this.header.classList.add("shopify-section-header-sticky", "shopify-section-header-show", "animate");
            this.header.classList.remove("shopify-section-header-hidden");
            document.querySelector("body").classList.remove("section-header-is-hidden");
          }
        }
      }
      reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === "always") {
            this.header.classList.add("shopify-section-header-sticky", "animate");
            return;
          } else {
            this.header.classList.remove(
              "shopify-section-header-hidden",
              "shopify-section-header-show",
              "shopify-section-header-sticky",
              "animate"
            );
            document.querySelector("body").classList.remove("section-header-is-hidden");
          }
        }
      }
      closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll("details-disclosure");
        this.disclosures.forEach((disclosure) => disclosure.close());
      }
    }
    customElements.define("sticky-header", StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-left-aligned"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-left-aligned');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-plain"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-plain');

if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
        super();
        }

        connectedCallback() {
        this.header = document.querySelector('.section-header-navigation');
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

        this.headerBounds = {};

        this.setHeaderHeight();

        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

        if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
        };

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
        }

        setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        });

        observer.observe(this.header);
        }

        onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            document.body.classList.add('scrolled-header');
            requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            document.body.classList.add('scrolled-header');

            if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
            } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
            }
        } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            document.body.classList.remove('scrolled-header');
            requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
        this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                this.header.classList.remove('shopify-section-header-hidden');
            }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
            }
            }
        }

        closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
        this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-utility"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-utility');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-vertical-menu"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-vertical-menu');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
                if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                    $('.vertical-menu').addClass('vertical-menu__hide');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            //   if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
            //       if (document.body.classList.contains('template-index')) {
            //           if ($('.vertical-menu').hasClass('vertical-menu__hide')) {
            //               $('.vertical-menu').removeClass('vertical-menu__hide');
            //           }
            //       }
            //   }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-top-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const scrollableContainers = document.querySelectorAll(".top-bar-menu");

    scrollableContainers.forEach((scrollableContainer) => {
      scrollableContainer.addEventListener("scroll", function (e) {
        const maxLeft = Math.max(0, scrollableContainer.scrollWidth - scrollableContainer.clientWidth);
        const scrollOffset = 10;

        scrollableContainer.parentElement.classList.toggle(
          "can-scroll-left",
          scrollableContainer.scrollLeft > scrollOffset
        );
        scrollableContainer.parentElement.classList.toggle(
          "can-scroll-right",
          scrollableContainer.scrollLeft < maxLeft - scrollOffset
        );
      });

      let isDragging = false;
      let startX;
      let scrollLeft;

      scrollableContainer.addEventListener("mousedown", function (e) {
        isDragging = true;
        startX = e.pageX - scrollableContainer.offsetLeft;
        scrollLeft = scrollableContainer.scrollLeft;
        scrollableContainer.style.cursor = "grabbing";
        scrollableContainer.style.userSelect = "none";
        e.preventDefault();
      });

      scrollableContainer.addEventListener("mousemove", function (e) {
        if (!isDragging) return;
        const x = e.pageX - scrollableContainer.offsetLeft;
        const walk = x - startX;
        scrollableContainer.scrollLeft = scrollLeft - walk;
      });

      function stopDragging() {
        isDragging = false;
        scrollableContainer.style.cursor = "";
        scrollableContainer.style.userSelect = "";
      }

      scrollableContainer.addEventListener("mouseup", stopDragging);
      scrollableContainer.addEventListener("mouseleave", stopDragging);

      scrollableContainer.dispatchEvent(new Event("scroll"));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    
  function setupvideoslideobserver() {
    const slides = document.querySelectorAll("video-gallery-element");

    if (!slides.length) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type !== "attributes" || mutation.attributeName !== "class") return;

        const slide = mutation.target;
        const video = slide.querySelector("video");
        const btnPlay = slide.querySelector(".video-toggle-play");
        if (!video) return;

        const isActive = slide.classList.contains("swiper-slide-active");

        if (isActive) {
          // Became active → play
          video.muted = true; // for autoplay safety
          video.play();
          btnPlay?.classList.add("playing");
        } else {
          video.pause();
          btnPlay?.classList.remove("playing");
        }
      });
    });

    slides.forEach((slide) => {
      observer.observe(slide, {
        attributes: true,
        attributeFilter: ["class"],
      });
    });
  }

  function playCenterVideo(swiper) {
    const swiperInstance = swiper ? swiper : document.querySelector(".video-gallery.swiper").swiper;

    if (swiperInstance) {
      swiperInstance.slides.forEach((slideEl, index) => {
        const video = slideEl.querySelector("video");
        const btnPlay = slideEl.querySelector(".video-toggle-play");
        if (!video) return; // no video in this slide

        if (index === swiperInstance.activeIndex) {
          video.muted = true;
          video.play();
          btnPlay?.classList.add("playing");
        } else {
          video.pause();
          btnPlay?.classList.remove("playing");
        }
      });
    }
  }

  function initVideoGallerySwiper(galleryEl) {
    if (!galleryEl || galleryEl.swiper) return;

    new Swiper(galleryEl, {
      slidesPerView: 1.25,
      spaceBetween: 10,
      slideToClickedSlide: true,
      centeredSlides: true,
      loop: true,
      on: {
        init: function (swiper) {
          setupvideoslideobserver();
          playCenterVideo(swiper);
        },
      },
      navigation: {
        nextEl: galleryEl.querySelector(".swiper-button-next"),
        prevEl: galleryEl.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        450: {
          slidesPerView: 1.4,
        },
        551: {
          slidesPerView: 2.08,
        },
        767: {
          slidesPerView: 2.8,
        },
        992: {
          slidesPerView: 3.4,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 10,
        },
        1400: {
          slidesPerView: 5,
          spaceBetween: 10,
        },
      },
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".video-gallery-section .video-gallery").forEach(initVideoGallerySwiper);
  });

  // A Section Rendering API troca o HTML da seção ao editar um bloco no editor de temas,
  // sem disparar DOMContentLoaded — sem isso o Swiper nunca reinicializa nas edições ao vivo,
  // os slides caem no CSS de fallback (width: 100%) e o vídeo (proporção em % da largura) estoura.
  document.addEventListener("shopify:section:load", function (event) {
    initVideoGallerySwiper(event.target.querySelector(".video-gallery"));
  });

  document.addEventListener("shopify:section:unload", function (event) {
    const galleryEl = event.target.querySelector(".video-gallery");
    if (galleryEl && galleryEl.swiper) {
      galleryEl.swiper.destroy(true, true);
    }
  });

  class VideoGallery extends HTMLElement {
    constructor() {
      super();
      this.videos = this.querySelectorAll("video-gallery-element");
    }

    connectedCallback() {}

    showPiP(activeIndex) {
      document.querySelector(".pip-gallery")?.remove();
      document.body.insertAdjacentHTML(
        "beforeend",
        `
          <div class="pip-gallery is-mute expanded">
            <div class="pip-gallery--wrapper">
              <button class="close-pip-gallery"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M 38.982422 6.9707031 A 2.0002 2.0002 0 0 0 37.585938 7.5859375 L 24 21.171875 L 10.414062 7.5859375 A 2.0002 2.0002 0 0 0 8.9785156 6.9804688 A 2.0002 2.0002 0 0 0 7.5859375 10.414062 L 21.171875 24 L 7.5859375 37.585938 A 2.0002 2.0002 0 1 0 10.414062 40.414062 L 24 26.828125 L 37.585938 40.414062 A 2.0002 2.0002 0 1 0 40.414062 37.585938 L 26.828125 24 L 40.414062 10.414062 A 2.0002 2.0002 0 0 0 38.982422 6.9707031 z"/></svg></button>
              <div class="pip-gallery--navigation">
                <button class="navigate navigate-up" aria-label="Ver vídeo de cima">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon icon-up">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 15.75 7.5-7.5 7.5 7.5" />
                  </svg>
                </button>
                <button class="navigate navigate-down" aria-label="Ver vídeo de baixo">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon icon-down">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                  </svg>
                </button>
              </div>
              <button aria-label="Mudo/Som" class="pip-gallery--mute">
                <span class="mute">
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 24 24" 
                    fill="currentColor" 
                    class="icon icon-mute" 
                  >
                    <path d="M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 0 0 1.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06ZM17.78 9.22a.75.75 0 1 0-1.06 1.06L18.44 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06l1.72-1.72 1.72 1.72a.75.75 0 1 0 1.06-1.06L20.56 12l1.72-1.72a.75.75 0 1 0-1.06-1.06l-1.72 1.72-1.72-1.72Z" />
                  </svg>
                </span>
                <span class="unmute">
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 24 24" 
                    fill="currentColor" 
                    class="icon icon-unmute"
                  >
                    <path d="M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 0 0 1.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06ZM18.584 5.106a.75.75 0 0 1 1.06 0c3.808 3.807 3.808 9.98 0 13.788a.75.75 0 0 1-1.06-1.06 8.25 8.25 0 0 0 0-11.668.75.75 0 0 1 0-1.06Z" />
                    <path d="M15.932 7.757a.75.75 0 0 1 1.061 0 6 6 0 0 1 0 8.486.75.75 0 0 1-1.06-1.061 4.5 4.5 0 0 0 0-6.364.75.75 0 0 1 0-1.06Z" />
                  </svg>
                </span>
              </button>
              <div class="pip-gallery-carousel">
              </div>
            </div>
          </div>
      `
      );

      const gallery = document.querySelector(".pip-gallery");
      const carousel = document.querySelector(".pip-gallery-carousel");
      this.videos.forEach((video, index) => {
        const controlsWrapper = document.createElement("div");
        controlsWrapper.classList.add("controls-wrapper");

        const shareBtn = video.querySelector(".video-share").cloneNode(true);
        shareBtn.insertAdjacentHTML("beforeend", `<span class="btn-tooltip">Compartilhar</span>`);

        controlsWrapper.appendChild(shareBtn);
        controlsWrapper.appendChild(video.form);

        const videoWrapper = document.createElement("div");
        videoWrapper.classList.add("video-wrapper");

        const videoEl = video.querySelector("video").cloneNode(true);

        const playBtn = document.createElement("button");
        playBtn.classList.add("play-wrapper");
        playBtn.insertAdjacentHTML(
          "beforeend",
          `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="icon icon-play">
              <path fill-rule="evenodd" d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z" clip-rule="evenodd"></path>
            </svg> 
          `
        );

        playBtn.addEventListener("click", function (e) {
          if (window.innerWidth > 1024 || (window.innerWidth <= 1024 && gallery.classList.contains("expanded"))) {
            videoWrapper.classList.toggle("playing");
            if (videoEl.paused) {
              videoEl.play();
            } else {
              videoEl.pause();
            }
          }
        });

        videoWrapper.appendChild(videoEl);
        videoWrapper.appendChild(controlsWrapper);
        videoWrapper.appendChild(playBtn);

        carousel.appendChild(videoWrapper);

        if (index == activeIndex) {
          videoWrapper.classList.add("playing");
          videoWrapper.classList.add("current");
          videoEl.play();
          videoEl.muted = true;
        }
      });

      const videoHeight = carousel.querySelector(".video-wrapper").offsetHeight;
      carousel.setAttribute("data-current-index", activeIndex);
      carousel.setAttribute("data-max-index", this.videos.length - 1);
      carousel.style.transform = `translateY(-${activeIndex * videoHeight}px)`;

      const mute = document.querySelector(".pip-gallery .pip-gallery--mute");
      const navUp = document.querySelector(".pip-gallery .navigate-up");
      const navDown = document.querySelector(".pip-gallery .navigate-down");

      mute.addEventListener("click", function (e) {
        gallery.classList.toggle("is-mute");
        const currVideo = carousel.querySelector(".video-wrapper.current");
        currVideo.querySelector("video").muted = gallery.classList.contains("is-mute");
      });

      navUp.addEventListener("click", function (e) {
        e.preventDefault();
        const currIndex = carousel.dataset.currentIndex;
        const maxIndex = carousel.dataset.maxIndex;

        if (currIndex === "0") return;

        const videoHeight = carousel.querySelector(".video-wrapper").offsetHeight;
        const currVideo = carousel.querySelector(".video-wrapper.current");
        currVideo.classList.remove("playing");
        currVideo.classList.remove("current");
        currVideo.querySelector("video").pause();

        const nextVideo = currVideo.previousElementSibling;
        nextVideo.classList.add("playing");
        nextVideo.classList.add("current");
        nextVideo.querySelector("video").play();
        nextVideo.querySelector("video").muted = gallery.classList.contains("is-mute");

        const newIndex = currIndex - 1;
        carousel.style.transform = `translateY(-${newIndex * videoHeight}px)`;
        carousel.setAttribute("data-current-index", newIndex);

        if (newIndex == 0) navUp.setAttribute("disabled", "disabled");
        if (newIndex < maxIndex) navDown.removeAttribute("disabled");
      });

      navDown.addEventListener("click", function (e) {
        e.preventDefault();
        const currIndex = carousel.dataset.currentIndex;
        const maxIndex = carousel.dataset.maxIndex;

        if (currIndex === maxIndex) return;

        const videoHeight = carousel.querySelector(".video-wrapper").offsetHeight;
        const currVideo = carousel.querySelector(".video-wrapper.current");
        currVideo.classList.remove("playing");
        currVideo.classList.remove("current");
        currVideo.querySelector("video").pause();

        const nextVideo = currVideo.nextElementSibling;
        nextVideo.classList.add("playing");
        nextVideo.classList.add("current");
        nextVideo.querySelector("video").play();
        nextVideo.querySelector("video").muted = gallery.classList.contains("is-mute");

        const newIndex = Number(currIndex) + 1;
        carousel.style.transform = `translateY(-${newIndex * videoHeight}px)`;
        carousel.setAttribute("data-current-index", newIndex);

        if (newIndex == maxIndex) navDown.setAttribute("disabled", "disabled");
        if (newIndex >= 1) navUp.removeAttribute("disabled");
      });

      let startX, startY, endX, endY;
      let isSwiping = false; // Flag to track if a swipe is in progress

      carousel.addEventListener("touchstart", function (e) {
        const touchStart = e.touches[0];
        startX = touchStart.clientX;
        startY = touchStart.clientY;
        isSwiping = false; // Reset the swipe flag
      });

      carousel.addEventListener("touchmove", function (e) {
        if (window.innerWidth <= 1024) {
          const touchMove = e.touches[0];
          endX = touchMove.clientX;
          endY = touchMove.clientY;

          const deltaY = endY - startY;

          if (Math.abs(deltaY) > Math.abs(endX - startX)) {
            isSwiping = true;
            e.preventDefault();
          }
        }
      });

      carousel.addEventListener("touchend", function (e) {
        if (window.innerWidth <= 1024) {
          if (gallery.classList.contains("expanded")) {
            const touchEnd = e.changedTouches[0];
            endX = touchEnd.clientX;
            endY = touchEnd.clientY;

            const deltaX = endX - startX;
            const deltaY = endY - startY;

            if (Math.abs(deltaX) < Math.abs(deltaY)) {
              if (deltaY > 25) {
                navUp.dispatchEvent(new Event("click"));
              } else if (deltaY < -25) {
                navDown.dispatchEvent(new Event("click"));
              }
            }
          }
        }
        isSwiping = false;
      });

      carousel.addEventListener("touchcancel", function () {
        isSwiping = false;
      });

      function shrinkGallery(event) {
        if (!gallery.contains(event.target) && !this.contains(event.target) && window.innerWidth <= 1024) {
          gallery.classList.remove("expanded");
        }
      }

      function debounce(fn, wait = 150, { leading = false } = {}) {
        let t,
          didLead = false;

        return (...args) => {
          const callNow = leading && !t && !didLead;
          clearTimeout(t);

          if (callNow) {
            didLead = true;
            fn(...args);
          }

          t = setTimeout(() => {
            t = null;
            didLead = false;
            if (!leading) fn(...args);
            else fn(...args); // trailing too
          }, wait);
        };
      }

      function recalculateGalleryPosition() {
        const currIndex = carousel.dataset.currentIndex;
        const videoHeight = carousel.querySelector(".video-wrapper").offsetHeight;
        carousel.style.transform = `translateY(-${currIndex * videoHeight}px)`;
        carousel.setAttribute("data-current-index", currIndex);
      }

      const closeBtn = document.querySelector(".close-pip-gallery");
      closeBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        document.querySelector(".pip-gallery")?.remove();
        document.removeEventListener("click", shrinkGallery.bind(this));
      });

      gallery.addEventListener("click", function (e) {
        if (window.innerWidth <= 1024) {
          gallery.classList.add("expanded");
        }
      });

      gallery.querySelectorAll(".product-form__submit, .video-share").forEach((btn) => {
        btn.addEventListener("click", () => {
          const currVideo = carousel.querySelector(".video-wrapper.current");
          currVideo.classList.remove("playing");
          currVideo.querySelector("video").pause();
        });
      });

      document.addEventListener("click", shrinkGallery.bind(this));
      window.addEventListener(
        "resize",
        debounce(
          () => {
            recalculateGalleryPosition();
          },
          200,
          { leading: true }
        )
      );
    }
  }

  customElements.define("video-gallery", VideoGallery);

  class VideoGalleryElement extends HTMLElement {
    constructor() {
      super();
      this.video = this.querySelector("video");
      this.form = this.createForm();
      this.btnPlay = this.querySelector(".video-toggle-play");
      this.btnMute = this.querySelector(".video-toggle-mute");
      this.btnPip = this.querySelector(".video-pip");
    }

    connectedCallback() {
      this.setupControls();
    }

    desconnectedCallback() {
      this.removeControls();
    }

    createForm() {
      const form = document.createElement("form");
      form.setAttribute("action", "/cart/add");
      form.setAttribute("method", "POST");
      form.setAttribute("data-product-id", this.dataset.productId);
      form.setAttribute("enctype", "multipart/form-data");

      const inputId = document.createElement("input");
      inputId.setAttribute("type", "hidden");
      inputId.setAttribute("name", "id");
      inputId.setAttribute("value", this.dataset.variantId);

      const inputQt = document.createElement("input");
      inputQt.setAttribute("type", "hidden");
      inputQt.setAttribute("name", "quantity");
      inputQt.setAttribute("value", 1);

      const button = document.createElement("button");
      button.setAttribute("id", "gallery-product-add-to-cart-" + this.dataset.productId + "-" + this.dataset.index);
      button.setAttribute("type", "submit");
      button.setAttribute("name", "add");
      button.setAttribute("data-btn-addtocart", "");
      button.setAttribute("data-available", this.dataset.available);
      button.classList = "product-form__submit button button--primary button--pip-form";
      button.insertAdjacentHTML(
        "beforeend",
        `
          <svg role="presentation" stroke-width="1.5" focusable="false" width="22" height="22" class="icon icon-cart  m-lr-auto w-h-24" viewBox="0 0 22 22">
            <path d="M11 7H3.577A2 2 0 0 0 1.64 9.497l2.051 8A2 2 0 0 0 5.63 19H16.37a2 2 0 0 0 1.937-1.503l2.052-8A2 2 0 0 0 18.422 7H11Zm0 0V1" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
          ${this.dataset.available == "true" ? '<span class="btn-tooltip">Adicionar</span>' : '<span class="btn-tooltip">Esgotado</span>'}
        `
      );
      if (this.dataset.available != "true") {
        button.setAttribute("disabled", "disabled");
      }

      form.appendChild(inputId);
      form.appendChild(inputQt);
      form.appendChild(button);

      return form;
    }

    setupControls() {
      if (!this.video) return;

      if (this.btnPlay && !this.btnPlay.classList.contains("listener-attached")) {
        this.btnPlay.classList.add("listener-attached");
        this.btnPlay.addEventListener("click", this.togglePlay.bind(this));
      }

      if (this.btnMute && !this.btnMute.classList.contains("listener-attached")) {
        this.btnMute.classList.add("listener-attached");
        this.btnMute.addEventListener("click", this.toggleMute.bind(this));
      }

      if (this.btnPip && !this.btnPip.classList.contains("listener-attached")) {
        this.btnPip.classList.add("listener-attached");
        this.btnPip.addEventListener("click", this.pipVideo.bind(this));
      }
    }

    removeControls() {
      this.btnPlay?.classList.remove("listener-attached");
      this.btnMute?.classList.remove("listener-attached");
      this.btnPip?.classList.remove("listener-attached");

      this.btnPlay?.removeEventListener("click", this.togglePlay.bind(this));
      this.btnMute?.removeEventListener("click", this.toggleMute.bind(this));
      this.btnPip?.removeEventListener("click", this.pipVideo.bind(this));
    }

    togglePlay(e) {
      e.stopPropagation();

      if (this.video.paused) {
        this.btnPlay.classList.add("playing");
        this.video.play().catch(() => {
          this.btnPlay?.classList.remove("playing");
        });
      } else {
        this.btnPlay.classList.remove("playing");
        this.video.pause();
      }
    }

    toggleMute(e) {
      e.stopPropagation();
      this.video.muted = !this.video.muted;
      this.btnMute.classList.toggle("playing", !this.video.muted);
    }

    pipVideo(e) {
      e.stopPropagation();
      e.preventDefault();

      const el = this.btnPip.closest(".swiper-slide-active");
      if (!el) return;
      this.video.pause();
      this.btnPlay.classList.remove("playing");
      const gallery = this.closest("video-gallery");
      gallery.showPiP(Number(this.dataset.index));
    }
  }

  customElements.define("video-gallery-element", VideoGalleryElement);

  } catch(e) { console.error(e); }
})();
})();
